type PendingWorkflowConsumption = {
  nextHandledWorkflowId: string | null
  shouldConsume: boolean
}

export function getPendingWorkflowConsumption(
  workflowId: string | null | undefined,
  handledWorkflowId: string | null
): PendingWorkflowConsumption {
  if (!workflowId) {
    return {
      nextHandledWorkflowId: null,
      shouldConsume: false,
    }
  }

  if (handledWorkflowId === workflowId) {
    return {
      nextHandledWorkflowId: handledWorkflowId,
      shouldConsume: false,
    }
  }

  return {
    nextHandledWorkflowId: workflowId,
    shouldConsume: true,
  }
}
